import React from "react";
import PropTypes from "prop-types";
import Contributor from "../../../../../atoms/contributor";
import { humanizeDate } from "../../../../../utils/time-format";
import { get } from "lodash";
import Icon from "../../../../../atoms/icon";
import { Link } from "@quintype/components";
import { getAuthorPath } from "../../../../../../data/author";
import { isPremium } from "../../../../../../../isomorphic/data/story";

import styles from "./styles.m.css";

class StoryHeader extends React.Component {
  constructor(props) {
    super(props);

    this.dropdown = null;

    this.state = {
      dropdown: false,
      showRelativeTime: false
    };

    this.handleDropdownClick = this.handleDropdownClick.bind(this);
    this.handleExternalClick = this.handleExternalClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", this.handleExternalClick);
    this.setState({ showRelativeTime: true });
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleExternalClick);
  }

  handleExternalClick(e) {
    this.setState({ dropdown: false });
  }

  handleDropdownClick = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.setState({ dropdown: !this.state.dropdown });
  };

  render() {
    const {
      story,
      renderSocialMedia = () => null,
      episodes,
      className,
      config,
      subheadline = true,
      readMore = true
    } = this.props;

    return (
      <div className={`${styles["story-header"]} ${className}`}>
        {readMore === true && (
          <div className={styles["published-time-wrap"]}>
            {story["first-published-at"] && (
              <span className={styles["published"]}>
                Published:
                <time className={styles.time} dateTime={new Date(story["first-published-at"]).toISOString()}>
                  {humanizeDate(story["first-published-at"], this.state.showRelativeTime ? "relative" : "absolute")}
                </time>
              </span>
            )}
            {story["last-published-at"] && (
              <span className={styles["updated"]}>
                Updated:
                <time className={styles.time} dateTime={new Date(story["last-published-at"]).toISOString()}>
                  {humanizeDate(story["last-published-at"], this.state.showRelativeTime ? "relative" : "absolute")}
                </time>
              </span>
            )}
          </div>
        )}
        {!isPremium(story)}
        {story.headline && <h1 className={styles.headline}>{story.headline}</h1>}
        {readMore === true && story.authors && story.authors.length ? (
          <div className={styles.contributors}>
            {story.authors.map((author, index) => {
              return (
                <Contributor
                  config={config}
                  path={getAuthorPath(author)}
                  key={author.id}
                  name={author.name}
                  type={get(author, ["contributor-role", "name"], "")}
                  iconColor="#4a4a4a"
                  className={styles["contributor"]}
                />
              );
            })}
          </div>
        ) : null}
        {readMore === true &&
          episodes && (
            <div className={styles["episode-dropdown-base"]}>
              <button
                aria-label="toggle dropdown"
                role="button"
                className={styles["selected-episode"]}
                onClick={this.handleDropdownClick}
                ref={element => {
                  this.dropdown = element;
                }}
              >
                <span>{story.headline}</span>
                <Icon type={this.state.dropdown ? "angle-up" : "angle-down"} className={styles["dropdown-icon"]} />
              </button>
              <ul className={`${styles["episodes-dropdown"]} ${this.state.dropdown ? "" : "hidden"}`}>
                {episodes.map(episode => (
                  <li key={episode.id} className={styles.episode}>
                    <Link aria-label="Episode" href={episode.url} className={styles["episode-link"]}>
                      {episode.headline}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        {renderSocialMedia("show-mobile-and-tablet")}
        {story.subheadline && subheadline ? (
          <p className={`${styles["mobile-hide"]} ${styles["sub-headline"]}`}>{story.subheadline}</p>
        ) : null}
      </div>
    );
  }
}

StoryHeader.propTypes = {
  story: PropTypes.shape({
    "first-published-at": PropTypes.number,
    "last-published-at": PropTypes.number,
    headline: PropTypes.string,
    subheadline: PropTypes.string,
    contributor: PropTypes.shape(Contributor.propTypes)
  }),
  episodes: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string,
      slug: PropTypes.string
    })
  ),
  renderSocialMedia: PropTypes.func,
  className: PropTypes.string,
  config: PropTypes.shape({
    cinemaMode: PropTypes.bool,
    disableAuthorLink: PropTypes.bool
  }),
  subheadline: PropTypes.bool,
  readMore: PropTypes.bool
};

export default StoryHeader;
